module.exports = __webpack_public_path__ + "static/media/volts.4e817b2e.png";